"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
var luhnAlgorithm_1 = require("../luhnAlgorithm");
var types_1 = require("../types");
var groupNumber = {
    1: types_1.CorporateIdentity.DeadEstate,
    2: types_1.CorporateIdentity.Government,
    3: types_1.CorporateIdentity.Foreign,
    5: types_1.CorporateIdentity.LimitedCompany,
    6: types_1.CorporateIdentity.SimpleCompany,
    7: types_1.CorporateIdentity.EconomicAssociation,
    8: types_1.CorporateIdentity.NonProfitOrganization,
    9: types_1.CorporateIdentity.TradingCompany,
};
function parse(input, options) {
    // checks that the input is of correct type
    if (typeof input !== "number" && typeof input !== "string") {
        return { valid: false, reason: types_1.CorporateIdentityNumberErrors.InputType, input: input };
    }
    // coerce input to string
    input = "" + input;
    /** Regex is:
     *  possible 2 digits (16), 6 digits,
     *  possible separator: -
     *  3 digits, 1 digit (checksum used in luhn algorithm)
     */
    // eslint-disable-next-line security/detect-unsafe-regex
    var reg = /^(\d{2}){0,1}(\d{1})(\d{1})(\d{2})(\d{2})([-]{0,1})?(\d{3})(\d{1})$/g;
    var group = reg.exec(input);
    // checks if input is of correct personal number format
    if (!group) {
        return { valid: false, reason: types_1.CorporateIdentityNumberErrors.Format, input: input };
    }
    // unpacks regex groups into letiables
    var orgIdentifierNum = group[1]; // in some cases org numbers start with the num 16
    var groupNum = group[2];
    var orgNum1 = group[3];
    var orgValidation = group[4];
    var orgNum3 = group[5];
    // const sep = group[6]
    var orgNum4 = group[7];
    var checkNum = group[8];
    if (+groupNum === 4) {
        return { valid: false, reason: types_1.CorporateIdentityNumberErrors.GroupNumber, input: input };
    }
    if (+orgValidation < 20) {
        return { valid: false, reason: types_1.CorporateIdentityNumberErrors.ValidationNumber, input: input };
    }
    if (orgIdentifierNum && +orgIdentifierNum !== 16) {
        return { valid: false, reason: types_1.CorporateIdentityNumberErrors.NumberIdentifer, input: input };
    }
    // validates control number using luhns algorithm
    if ((0, luhnAlgorithm_1.luhnAlgorithm)("" + groupNum + orgNum1 + orgValidation + orgNum3 + orgNum4) !== +checkNum) {
        return { valid: false, reason: types_1.CorporateIdentityNumberErrors.Checksum, input: input };
    }
    var type = groupNumber[+groupNum];
    var normalised = "";
    if (options.shortNormalisation) {
        // Format: NNNNNN-NNNN
        normalised = groupNum + orgNum1 + orgValidation + orgNum3 + "-" + orgNum4 + checkNum;
    }
    else {
        // FORMAT: 16NNNNNNNNNN
        normalised = "16" + groupNum + orgNum1 + orgValidation + orgNum3 + orgNum4 + checkNum;
    }
    return { valid: true, type: type, input: input, normalised: normalised };
}
exports.parse = parse;
